import { ReactNode } from 'react';

import { Badge } from '@ui/components/Badge';

type Props = {
  href: string;
  download?: boolean;
  highlighted?: boolean;
  children: ReactNode;
};

export function TournamentLinkBadge({ href, download, highlighted, children }: Props) {
  return (
    <Badge size="m" flat href={href} download={download} highlighted={highlighted}>
      {children}
    </Badge>
  );
}
